import { observer } from 'mobx-react-lite'

import { useCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { StatusCell } from '@/Ship/Components/UI/StatusBadge/StatusCell'

import type { StatusOption } from '@/Ship/Components/UI/StatusBadge/StatusBadge'

/** Статус, після якого запис зникає з реєстру — картку закриваємо */
const TERMINAL_STATUS = 'deleted'

interface UserStatusFieldProps {
    formContext: any
}

/**
 * «Статус» у картці співробітника: бейдж із меню зміни в перегляді й редагуванні.
 * Статус змінюється окремим запитом (change_status), а не збереженням форми, тому поле
 * не йде через FormField: у ядра власний view оминає шаблон поля (без лейбла), а
 * інпут у формі вимкнений. Розмітка — як у Ship-шаблонів поля для відповідного режиму.
 */
export const UserStatusField = observer(({ formContext }: UserStatusFieldProps) => {
    const crudContext = useCrudResourceContext() as any
    const definition = crudContext?.resource?.fields?.status ?? {}
    const value = formContext.values?.status

    if (typeof value !== 'string' || value === '') return null

    // depFn ресурсу вимикає інпут статусу у формі; на меню зміни це не поширюється
    const field = { ...definition, inputProps: { ...definition.inputProps, disabled: false } }

    const handleChanged = (option: StatusOption) => {
        if (option.value === TERMINAL_STATUS) {
            crudContext?.closeResourceDetail?.()
            return
        }
        // Оновлюємо і початкове значення: зміна вже збережена, картка не має стати «брудною»
        formContext.setInitialValue('status', option.value)
    }

    const cell = (
        <StatusCell
            value={value}
            field={field}
            item={formContext.initialValues ?? {}}
            crudContext={crudContext}
            onChanged={handleChanged}
        />
    )

    if (formContext.isEditable) {
        return (
            <div className="form-field form-field-default">
                <span className="field-label">{definition.label ?? 'Статус'}</span>
                <div>{cell}</div>
            </div>
        )
    }

    return (
        <div className="form-field-view">
            <div className="field-view-label">{definition.label ?? 'Статус'}</div>
            <div className="field-view-value">{cell}</div>
        </div>
    )
})
